var render, staticRenderFns
import script from "./TextButton.vue?vue&type=script&lang=ts&"
export * from "./TextButton.vue?vue&type=script&lang=ts&"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=295ad5a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports